<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">About Cyber Nexus Solutions</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><router-link to="/">Home</router-link></li>
                                            <li class="text-white active">About Us</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- BradCrumb header End -->

        <!-- Start About Content -->
        <section class="section about-inner">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="title-section">
                            <h2>Your Local Partner for Mission-Critical IT</h2>
                        </div>
                        <div class="para-text text-left mt-4">
                            <p>Cyber Nexus Solutions was founded in Laredo, Texas, with a clear mission: to provide serious, reliable IT and security services for the businesses that form the backbone of the South Texas economy. We saw a need for an IT partner that understands the demanding environments of industrial, energy, and logistics operations—a partner that values uptime and security above all else.</p>
                            <p>Our background isn't in retail computer repair; it's in the field, supporting critical infrastructure where failure is not an option. We bring that same level of discipline and proactive planning to every client we serve, from multi-site commercial operations to professional firms with sensitive data.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="about-video-sec">
                            <img src="assets/images/aboutus/about-inner.jpg" alt="Cynexsol team working on a network rack in South Texas" class="w-100 img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End About Content -->

        <!-- Start Mission Section -->
        <section class="section about-bottom bg-light">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-sm-6">
                        <div class="text-center">
                            <div class="about-inner-text">
                                <span class="icon transition mdi mdi-bullseye-arrow theme-color f-40"></span>
                                <h4 class="my-3 theme-color">Our Mission</h4>
                                <p class="para-text mb-0">To deliver proactive, resilient, and secure IT solutions that reduce operational risk and ensure our clients' business continuity. We succeed when your operations run without interruption.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="text-center">
                            <div class="about-inner-text">
                                <span class="icon transition mdi mdi-map-marker-radius theme-color f-40"></span>
                                <h4 class="my-3 theme-color">Local Expertise</h4>
                                <p class="para-text mb-0">As a Laredo-based company, we have a deep understanding of the unique challenges and opportunities in the South Texas and Eagle Ford region. We are your neighbors, invested in our community's success.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="text-center">
                            <div class="about-inner-text">
                                <span class="icon transition mdi mdi-shield-check theme-color f-40"></span>
                                <h4 class="my-3 theme-color">Focus on Security</h4>
                                <p class="para-text mb-0">We believe robust security is not an add-on; it's the foundation. From network design to managed support, every service we provide is built with a security-first mindset to protect your assets.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Mission Section -->
    </div>
</template>
<script>
    export default {
        name: 'about'
    }
</script>
